module.exports = __webpack_public_path__ + "img/gallery-image-3.7c48d331.png";